import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LanguageService } from '../../../core/services';
import { Language } from '../../../core/services/lang/language';
import { TranslationPipe } from '../../../shared/pipes';

@Component({
  selector: 'app-country-select',
  standalone: true,
  imports: [FormsModule, NgFor, TranslationPipe],
  templateUrl: './country-select.component.html',
  styleUrl: './country-select.component.scss'
})
export class CountrySelectComponent {
  selected: Language = Language.Czech;
  selectTitle: string = 'Výběr jazyka';
  countries = [
    { name: 'Česky', code: Language.Czech },
    { name: 'Polski', code: Language.Polish },
    { name: 'English', code: Language.English }
  ];

  constructor(private readonly router: Router, private readonly languageService: LanguageService) {
    this.languageService = languageService;
    this.selected = this.languageService.language;
    const savedLang = localStorage.getItem('lang');
    if (savedLang) {
      this.languageService.setLocale(savedLang as Language);
      this.selected = savedLang as Language;
    }
  }

  ngOnInit() {
    this.selectTitle = this.languageService.translate(this.selectTitle);
  }

  change(value: string) {
    const lang = value as Language;
    this.languageService.setLocale(lang);
    localStorage.setItem('lang', lang);

    if (this.router.url != '/')
      // mimo root nelze provést reload
      this.router.navigateByUrl("");

    location.reload();
  }
}
